import styled from "@emotion/styled";
import { Switch, Typography } from "@mindlercare/ui-web";
import { useSyncExternalStore } from "react";
import { useTranslation } from "../hooks/useTranslation";
import { useInternalAuth } from "../AuthenticationProvider";

const PASSKEY_OPT_OUT_KEY = "passkey-opt-out";

export const checkPasskeyOptOut = () => {
  const passkeyOptOut = localStorage.getItem(PASSKEY_OPT_OUT_KEY);
  return passkeyOptOut === "true";
};

const togglePasskeyOptOut = () => {
  const passkeyOptOut = checkPasskeyOptOut();
  localStorage.setItem(PASSKEY_OPT_OUT_KEY, (!passkeyOptOut).toString());
  window.dispatchEvent(new Event("auth:passkey-opt-out"));
};

const subscribe = (callback: () => void) => {
  window.addEventListener("auth:passkey-opt-out", callback);

  return () => {
    window.removeEventListener("auth:passkey-opt-out", callback);
  };
};

export const usePasskeyOptOut = (): [boolean, () => void] => {
  const passkeyOptOut = useSyncExternalStore(subscribe, checkPasskeyOptOut);
  return [passkeyOptOut, togglePasskeyOptOut];
};

export const PasskeyOptOutToggle = () => {
  const { t } = useTranslation();
  const { passkeySupported } = useInternalAuth();
  const [isOptedOut, toggle] = usePasskeyOptOut();

  return passkeySupported ? (
    <StyledDiv>
      <Switch isLeft isActive={isOptedOut} onClick={() => toggle()} />
      <Typography variant="body-x-small" color={"GRAY_DARK"}>
        {t("PASSKEY_OPT_OUT")}
      </Typography>
    </StyledDiv>
  ) : null;
};

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
`;
